export default __webpack_public_path__ + "static/media/Loading.19fc6612.gif";